module.exports = __webpack_public_path__ + "static/media/Connecter.e357a59b.jpg";